<template>
    <div class="confirmation withdraw-confirmation">
        <img :src="require(`@webapp/assets/statuses/processing.webp`)"
            class="image"
        >

        <div class="content">
            <div v-if="reference"
                class="content__reference"
            >
                {{ reference }}
            </div>

            <div class="content__title">{{ $t('sendOut.processingMessage') }}</div>
        </div>

        <div class="buttons">
            <div id="button-confirm"
                class="buttons__item buttons__item--success"
                @click="callback"
            >
                {{ label }}
            </div>
        </div>
    </div>
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Local Types
import localEpicTypes from '@webapp/store/types.js';

export default {
    name: 'confirmation-modal',
    data() {
        return {
            method: null,
        };
    },
    computed: {
        ...mapGetters(['modal']),

        reference() {
            return Object.keys(this.modal.data).length
                ? this.modal.data.reference
                : '';
        },

        label() {
            return this.modal?.data?.label || this.$t('global.transactionHistory');
        },
    },
    methods: {
        ...mapActions({
            resetModal: localEpicTypes.RESET_MODAL,
        }),

        navigateToTransactions() {
            this.resetModal();
            this.$router.push('/wallet/transactions');
        },

        callback() {
            return Object.keys(this.modal.data).includes('callback')
                ? this.modal.data.callback() && this.resetModal()
                : this.navigateToTransactions();
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmation {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.content {
    padding-top: 2.6rem;
    background: $white-color;
    text-align: center;
    color: $cyprus-color;
    flex: 1;

    @include max-width(sm) {
        padding-top: 2.6rem;
    }

    &__reference {
        color: $daintree-color;
        font-size: 1.1rem;
        line-height: 2.2rem;
        opacity: 0.65;
        padding-bottom: 1.2rem;
    }

    &__title {
        font-size: 2.2rem;
        font-weight: 700;
        line-height: 3.4rem;
        padding-bottom: 2.2rem;

        @include min-width(md) {
            font-size: 2.5rem;
        }

        @include max-width(sm) {
            font-size: 2rem;
        }
    }
}

.image {
    display: block;
    margin: 0 auto;
    object-fit: contain;
    max-width: 13.6rem;
    min-height: 12rem;

    @include min-width(md) {
        max-width: 15.6rem;
        min-height: 16rem;
    }

    @include max-width(sm) {
        max-width: 9.6rem;
        min-height: 11rem;
    }
}

.buttons {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 2rem 0;
    width: 100%;

    &__item {
        text-align: center;
        font-size: 1.5rem;
        line-height: 1.5rem;
        width: 34rem;
        margin: 2rem 0 0;
        cursor: pointer;

        @include max-width(sm) {
            width: 25rem;
        }

        &--success {
            margin-top: 0;
            line-height: 4rem;
            border-radius: 0.4rem;
            color: $daintree-color;
            background: $lima-color;
        }
    }
}
</style>